
import React from 'react';


import MockStock2025  from 'views/MockStock2025';
const MiddleSchoolPage = () => {
  return <MockStock2025/>;
};

export default MiddleSchoolPage;